import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Button from "@components/Button";

import { useGetInquiryDetail } from "@api/inquiry";

import { EStatus, type ResponseGetDetailInquiry } from "@schemas/inquiry";

import { formatDate } from "@utils/format";

import PathContants from "@routers/pathConstants";

import "./style.scss";

const MeInquiryDetailPage = () => {
	const { id } = useParams();
	const [data, setData] = useState<ResponseGetDetailInquiry | null>(null);
	const { mutateAsync: getInquiryDetail } = useGetInquiryDetail();
	const navigate = useNavigate();
	useEffect(() => {
		const fetchInquiryDetail = async () => {
			const res = await getInquiryDetail({ id: Number(id), data: { password: "" } });
			if (res.data) {
				setData(res.data);
			}
		};
		fetchInquiryDetail();
	}, [id]);

	if (!data) return null;

	const handleGoToList = () => {
		navigate(PathContants.meInquiry, {
			replace: true,
		});
	};

	return (
		<div className="me-inquiry-detail-page">
			<div className="me-inquiry-detail-page__title">
				<h1>1:1 문의내역</h1>
			</div>
			<div className="me-inquiry-detail-page__content">
				<div className="me-inquiry-detail-page__content-info ">
					<div className="me-inquiry-detail-page__content-info-title">
						<h2>{data?.title}</h2>
						<div className="tag-wrapper__item">
							{data?.status === EStatus.PENDING ? "대기중" : "답변완료"}
						</div>
					</div>
					<div className="me-inquiry-detail-page__content-info-content">
						<p>{data?.content}</p>
						<span className="me-inquiry-detail-page__content-info-content-date">
							{formatDate(data?.createdAt)}
						</span>
					</div>
				</div>
				{data?.status === EStatus.ANSWERED && (
					<div className="me-inquiry-detail-page__content-info answered">
						<div className="me-inquiry-detail-page__content-info-content">
							<p>{data?.answerContent}</p>
							<span className="me-inquiry-detail-page__content-info-content-date">
								{formatDate(data?.answeredAt)}
							</span>
						</div>
					</div>
				)}
			</div>
			<Button
				className="me-inquiry-detail-page__button"
				label="목록으로"
				color="black"
				onClick={handleGoToList}
			/>
		</div>
	);
};

export default MeInquiryDetailPage;
